const contactText = [
  {
    heading: "Contact",
    wego: "Wego transport, UAB",
    address: "Address: Laisves pr. 77E, LT-06155 Vilnius",
    code: "Company code: 302442803",
    vat: "VAT code: LT100004943510",
    bank: "Bank: SEB BANKAS",
    acc: "Acc. No.: LT377044060007323417",
    bankCode: "Bank code: 70440",
    swift: "Swift code: CBVILT2X",
  },
  {
    heading: "Kontaktai",
    wego: "Wego transport, UAB",
    address: "Adresas: Laisvės pr. 77E, LT-06155 Vilnius",
    code: "Įmonės kodas: 302442803",
    vat: "PVM kodas LT100004943510",
    bank: "Bankas:  SEB BANKAS",
    acc: "Sąsk. Nr: LT377044060007323417",
    bankCode: "Banko kodas: 70440",
    swift: "Swift kodas: CBVILT2X",
  },
  {
    heading: "Kontakty",
    wego: "Wego transport, UAB",
    address: "Adres: Laisves pr. 77E, LT-06155 Wilno",
    code: "REGON: 302442803",
    vat: "NIP: LT100004943510",
    bank: "Bank: SEB BANKAS",
    acc: "Numer konta / IBAN: LT377044060007323417",
    bankCode: "Kod banku: 70440",
    swift: "Kod Swift: CBVILT2X",
  },
];

export default contactText;
